import React from "react";
import "../Styles/Loader.css";

export default function Loader() {
  return (
    <div className="global-loader-wrapper">
      <div className="global-loader"></div>
    </div>
  );
}
